import PropTypes from 'prop-types';
import React from 'react';
import { AvatarCircle } from './StyledComponents';

const getInitials = (firstName, lastName) => {
  const first = (firstName || '').trim().charAt(0);
  const last = (lastName || '').trim().charAt(0);
  return `${first}${last}` || '?';
};

const Avatar = ({ firstName, lastName, size = 'medium', className }) => (
  <AvatarCircle size={size} className={className}>
    {getInitials(firstName, lastName)}
  </AvatarCircle>
);

Avatar.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
};

export default Avatar;
